var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C9.30556 25 6.52199 23.941 4.14931 21.8229C1.77662 19.7049 0.416666 17.0602 0.0694444 13.8889L2 13.8889C2.32407 16.2963 3.18287 18.4259 5 20C6.81713 21.5741 10.0694 23 12.5 23C15.2083 23 18.6134 21.3866 20.5 19.5C22.3866 17.6134 23 15.2083 23 12.5C23 9.79167 21.8866 6.88657 20 5C18.1134 3.11343 15.2083 2 12.5 2C10.9028 2 8.88889 2.25926 7.5 3C6.11111 3.74074 3.38071 6.44354 2.43164 7.73984L6.93164 7.73984V9.73984L0 9.72222V1.38889L2 1.38889V5C3.18055 3.51852 5.39931 2.02546 7.10069 1.21528C8.80208 0.405093 10.6019 0 12.5 0C14.2361 0 15.8623 0.329862 17.3785 0.989583C18.8947 1.6493 20.2141 2.54051 21.3368 3.66319C22.4595 4.78588 23.3507 6.10532 24.0104 7.62153C24.6701 9.13773 25 10.7639 25 12.5C25 14.2361 24.6701 15.8623 24.0104 17.3785C23.3507 18.8947 22.4595 20.2141 21.3368 21.3368C20.2141 22.4595 18.8947 23.3507 17.3785 24.0104C15.8623 24.6701 14.2361 25 12.5 25ZM16.3889 18.3333L11.1111 13.0556V5.55555L12.9316 5.55556L12.9316 11.7398L17.9316 16.7398L16.3889 18.3333Z",
    fill: "#6C7A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.507edbc1ff1f5d1ae1c9e4a2740d36a9.svg";
export { ForwardRef as ReactComponent };